exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Wa_zSlDqEC_35{padding:0 12px}", ""]);

// exports
exports.locals = {
	"atlassianAppSwitcherContainer": "_2Wa_zSlDqEC_35"
};